"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionTitle = void 0;
var index_1 = require("../../i18n/index");
exports.CollectionTitle = {
    view: function (title) {
        if (title == null || title === '') {
            return (0, index_1.Translate)(index_1.T.COLLECTION_MISSING_TITLE);
        }
        return title;
    }
};
//# sourceMappingURL=collection.title.js.map